import { injectable } from 'inversify';
import { observable } from 'mobx';

export type DestinationTitle = {
  title: string;
  destinationSignature: string;
};
@injectable()
export class DestinationTitlesRegistry {
  titles = observable.map<string, DestinationTitle>({});
}
